
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { FarPayResponseModel } from 'models/generated/GormGateway.Models.FarPayResponse';


const _gormGateway_FarPayControllerHelper = new Map<string, Object>();
_gormGateway_FarPayControllerHelper.set('FindCustomers', FarPayResponseModel);


export const gormGateway_FarPayControllerHelper = _gormGateway_FarPayControllerHelper;

